import { createStore } from 'vuex'

export default createStore({
  state: {
    role: null,
    email_verified: null,
    discord_verified: null,
    credits: null,
    server_slots: null,
    server_count: null,
    name: null,
    isSidebarOpen: true,
  },
  getters: {
    getData(state) {
      return { 
        role: state.role, 
        email_verified: state.email_verified, 
        discord_verified: state.discord_verified, 
        credits: state.credits, 
        server_slots: state.server_slots,
        server_count: state.server_count,
        name: state.name
      }
    },
    sidebarWidth: (state) => (state.isSidebarOpen ? '160px' : '50px'),
  },
  mutations: {
    setData(state, payload) {
      state.role = payload.role
      state.email_verified = payload.email_verified
      state.discord_verified = payload.discord_verified
      state.credits = payload.credits
      state.server_slots = payload.server_slots
      state.server_count = payload.server_count
      state.name = payload.name
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebar(state, isOpen) {
      state.isSidebarOpen = isOpen;
    },
  },  
  actions: {
    updateData({ commit }, payload) {
      commit("setData", payload);
    },
    toggleSidebar({ commit }) {
      commit('toggleSidebar');
    },
    setSidebar({ commit }, isOpen) {
      commit('setSidebar', isOpen);
    },
  },
  modules: {
  }
})
